// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"08d991c6","783":"4ac16e05","974":"843c8460","992":"52758278"}[chunkId] + ".chunk.js";
};